const FeeTypes = {
    1: "Basic Security",
    2: "Building",
    3: "Tenant"
  };
  
  /**
   * Get the FeeTypeId by FeeTypeName.
   * @param {string} feeTypeName - The name of the FeeType.
   * @returns {number|null} The FeeTypeId if found, otherwise null.
   */
  export const getFeeTypeIdByName = (feeTypeName) => {
    return parseInt(
      Object.keys(FeeTypes).find((key) => FeeTypes[key] === feeTypeName),
      10
    ) || null;
  };
  
  /**
   * Get the FeeTypeName by FeeTypeId.
   * @param {number} feeTypeId - The ID of the FeeType.
   * @returns {string|null} The FeeTypeName if found, otherwise null.
   */
  export const getFeeTypeNameById = (feeTypeId) => FeeTypes[feeTypeId] || null;
  
  export default FeeTypes;
  